import { createTextComponent } from './createTextComponent';

export const H3 = createTextComponent({
  styleAs: 'h3',
  tag: 'h3',
});
